<template>
 <div class="my-box">

  <el-dialog title="添加员工" top="5%" :visible.sync="showDialog" width="40%">
   <el-form :model="addform" ref="addform" :rules="myrules" label-width="100px">
    <el-form-item label="品牌" prop="brand">
     <el-select v-model="addform.brand" @change="selectOne" filterable clearable placeholder="请选择">
      <el-option v-for="(item,index) in brandSelectData" :key="index" :label="item.brandName" :value="item.id+and+item.brandName"></el-option>
     </el-select>
    </el-form-item>
    <el-form-item label="门店" prop="hotel">
     <el-select v-model="addform.hotel" clearable filterable placeholder="请选择">
      <el-option v-for="(item,index) in hotelSelectData" :key="index" :label="item.name" :value="item.id+and+item.name"></el-option>
     </el-select>
    </el-form-item>
    <el-form-item label="职位" prop="position">
     <el-select v-model="addform.position" clearable placeholder="请选择">
      <el-option v-for="(item,index) in cardTypes" :key="index" :label="item.label" :value="item.value"></el-option>
     </el-select>
    </el-form-item>
    <!-- <el-form-item label="权限" prop="brandId">
     <el-select v-model="addform.floorId" clearable placeholder="请选择">
      <el-option v-for="(item,index) in floorSelectData" :key="index" :label="item.floorName" :value="item.id"></el-option>
     </el-select>
    </el-form-item> -->
    <el-form-item label="卡类型" prop="cardType">
     <el-select v-model="addform.cardType" clearable filterable placeholder="请选择">
      <el-option v-for="(item,index) in cardTypes" :key="index" :label="item.label" :value="item.value"></el-option>
     </el-select>
    </el-form-item>
    <el-form-item label="卡号" prop="cardSn">
     <el-input v-model.trim="addform.cardSn" placeholder="请输入内容" maxlength="15"></el-input>
    </el-form-item>

    <el-form-item label="姓名" prop="employeeName">
     <el-input v-model.trim="addform.employeeName" placeholder="请输入内容" maxlength="15"></el-input>
    </el-form-item>
     <el-form-item label="手机号码" prop="phoneNumber">
     <el-input v-model.trim="addform.phoneNumber" placeholder="请输入内容" maxlength="15"></el-input>
    </el-form-item>
    
   </el-form>
   <div slot="footer" class="dialog-footer">
    <el-button @click="showDialog=false">取 消</el-button>
    <el-button type="primary" @click="confirmAdd('addform')" :loading="loading">确 定</el-button>
   </div>
  </el-dialog>
 </div>
</template>
<script>
import { trackDetail, getHotelSelect, workerAdd } from "@/api";
import { getLongDateTime, secondGetLongTime, showLabel } from "@/api/common.js";

export default {
 props: ["brandSelectData"],
 data() {
  return {
   and: "-and-",
   loading: false,
   showDialog: false,
   addform: {
    hotel: null,
    brand: null,
    position: null,
    cardType: null,
    cardSn: null,
    employeeName: null,
    phoneNumber:null
   },
   floorSelectData: [],
   hotelSelectData: [],
   myrules: {
    hotel: [{ required: true, message: "请选择", trigger: "change" }],
    brand: [{ required: true, message: "请选择", trigger: "change" }],
    position: [{ required: true, message: "请选择", trigger: "change" }],
    // phoneNumber: [{ required: true, message: "请选择", trigger: "change" }],
    phoneNumber: [
      { required: true,  message: "请输入手机号码", trigger: "blur" },
      { pattern:/^1[345789]\d{9}$/,  message: "请填写正确的手机号码", trigger: "blur" }

      
      ],
    employeeName: [
     { required: true, message: "请选择", trigger: "blur" },
     { max: 10, message: "最多可输入 10 个字符", trigger: "blur" },
    ],
   },
  };
 },
 computed: {
  cardTypes() {
   return this.$store.state.cardTypes;
  },
 },
 methods: {
  selectOne(val) {
   this.addform.hotel = null;
   let id = val.split(this.and)[0];
   getHotelSelect(id).then((res) => {
    if (res.data.data) {
     this.hotelSelectData = res.data.data;
     console.log(this.hotelSelectData, "; this.hotelSelectData");
    } else {
     this.$message({
      message: "该品牌下没有门店数据",
      type: "warning",
     });
    }
   });
  },
  // 时长
  showLongTimes(val) {
   return secondGetLongTime(val);
  },

  openSet() {
   this.showDialog = true;
   this.addform = {
    hotel: null,
    brand: null,
    position: null,
    cardType: null,
    cardSn: null,
    employeeName: null,
   };
  },
  getData(obj) {
   let data = {};
   let brand = obj.brand.split(this.and);
   data.brandId = brand[0];
   data.brandName = brand[1];
   let hotel = obj.hotel.split(this.and);
   data.hotelId = hotel[0];
   data.hotelName = hotel[1];
   data.position = obj.position;
   data.cardType = obj.cardType;
   data.cardSn = obj.cardSn;
   data.employeeName = obj.employeeName;
   data.phoneNumber = obj.phoneNumber;
   
   return data;
  },
  confirmAdd(formName) {
   // addform.province = selectedOptions
   this.$refs[formName].validate((valid) => {
    if (valid) {
     this.loading = true;
     let data = this.getData(this.addform);
     console.log(data);
     workerAdd(data)
      .then((res) => {
       console.log(res);
       this.loading = false;
       if (res.data.code == "000000") {
        this.$message.success(res.data.message);
        this.showDialog = false;
        this.$parent.getList();
       } else {
        this.$message.error(res.data.message);
       }
      })
      .catch((err) => {
       console.log(err);
       this.loading = false;
      });
    } else {
     console.log("error submit!!");
     return false;
    }
   });
  },
 },
};
</script>
<style lang="scss" scoped>


</style>


